import { FileClient } from "clients/rest";

export type B060020Request = { kakolisthakozumiKbn: string } & Partial<{
  seisakuYmdFrom: string;
  seisakuYmdTo: string;
  seizoNoFrom: string;
  seizoNoTo: string;
  juchudenpyoNoFrom: string;
  juchudenpyoNoTo: string;
  kakoshubetsuCdFrom: string;
  kakoshubetsuCdTo: string;
  shohinCdFrom: string;
  shohinCdTo: string;
  janCdFrom: string;
  janCdTo: string;
  shohinshubetsuKbn: string;
}>;

// 印刷処理
export const B060020Print = (props: B060020Request) => {
  return FileClient.put("b060020/print", props);
};
